import { createFileRoute } from "@tanstack/react-router"

import { ClientRedirect } from "../../../../components/ClientRedirect"
import { SpinnerLayout } from "../../../../components/layouts/SpinnerLayout"
import { LINKS } from "../../../../routing/links"
import { useStepsRouting } from "../../../../routing/useStepsRouting"

export const Route = createFileRoute("/$sessionId/_session/guide/")({
  component: GuideIndex,
})

function GuideIndex() {
  const { sessionId } = Route.useParams()
  const { firstUnfinishedStepLink, isLoading } = useStepsRouting(sessionId)

  if (isLoading) return <SpinnerLayout />

  return <ClientRedirect to={firstUnfinishedStepLink ?? LINKS.finish(sessionId)} />
}
